// extracted by mini-css-extract-plugin
export default {"AuthHeading":"styles_AuthHeading__nNfMM"};